import * as TypesStudent from '../types/types_student';
import Vue from 'vue';
import Enums from '@/constants/enum';
import Moment from 'moment';
import _ from 'lodash';
export default {
    state: {
        baseInfo: {
            studentId: '',
            name: '',
            avatar: '',
            schoolName: '',
            grade: '',
            paymentPhase: 0,
            managerType: 0,
            managerName: '',
            managerPhone: ''
        },
        plan: {},
        course: [],
        studentList: [],
        studentRecentLesson: {},
        selectCourse: {},
        tutorSubject: {},
        historyCourse: {},
        homeworkList: [],
        hasPendingHomework: false // 是否存在待批改作业
    },
    mutations: {
        [TypesStudent.STUDENT_SET_BASE_INFO](state, payload) {
            state.baseInfo = payload || {
                id: '',
                name: '',
                avatar: '',
                schoolName: '',
                grade: '',
                paymentPhase: 0,
                managerType: 0,
                managerName: '',
                managerPhone: ''
            };
        },
        [TypesStudent.STUDENT_SET_RECENT_LESSON](state, payload) {
            state.studentRecentLesson = payload || {};
        },
        [TypesStudent.STUDENT_GET_TUTOR_SUBJECT](state, payload) {
            state.tutorSubject = payload || {};
        },
        [TypesStudent.STUDENT_SET_PLAN](state, payload) {
            state.plan = payload || {};
        },
        [TypesStudent.STUDENT_SET_HISTORY_COURSE](state, payload) {
            state.historyCourse = payload || {};
        },
        [TypesStudent.STUDENT_SET_HOMEWORK_LIST](state, payload) {
            state.homeworkList = payload || [];
        },
        // 课程规划操作 - 修改某课节知识点
        [TypesStudent.STUDENT_PLAN_EDIT_LESSON](state, payload) {
            // payload -> lessonIndex, knowledgePoints, lessonName
            let targetIndex = payload.lessonIndex - 1;
            let lesson = state.plan.lessons[targetIndex];
            if (lesson) {
                let knowledgeArray = [];
                payload.knowledgePoints && payload.knowledgePoints.forEach(point => {
                    knowledgeArray.push(point.name);
                });
                lesson.knowledgePoints = payload.knowledgePoints || [];
                lesson.knowledges = knowledgeArray.join(';');
                lesson.name = payload.lessonName;
            }
        },
        // 课程规划操作 - 删除某课节
        [TypesStudent.STUDENT_PLAN_DELETE_LESSON](state, payload) {
            // payload -> lessonIndex, lessonLength
            let lessons = _.clone(state.plan.lessons);
            let targetIndex = payload.lessonIndex - 1;
            let lessLen = payload.lessonLength - 1;
            let targetLesson = lessons[targetIndex];
            if (targetLesson && !targetLesson.isFinished) {
                lessons.splice(targetIndex, 1);
                for (let i = targetIndex; i < lessLen; i++) {
                    lessons[i]['index'] = i + 1;
                }
                state.plan.lessons = lessons;
            }
        },
        // 课程规划操作 - 下方增加课节
        [TypesStudent.STUDENT_PLAN_ADD_LESSONS](state, payload) {
            // payload -> lessonIndex, lessonLength, nextLessons
            let lessons = _.clone(state.plan.lessons);
            let targetIndex = payload.lessonIndex - 1;
            let lastLessons = lessons.splice(targetIndex);
            let nextLen = payload.nextLessons.length;
            for (let i = 0; i < nextLen; i++) {
                targetIndex++;
                payload.nextLessons[i]['index'] = targetIndex;
            }
            let lasttLen = lastLessons.length;
            for (let j = 0; j < lasttLen; j++) {
                targetIndex++;
                lastLessons[j]['index'] = targetIndex;
            }
            let newLessons = lessons.concat(payload.nextLessons, lastLessons);
            state.plan.lessons = newLessons;
        },
        [TypesStudent.STUDENT_PLAN_UP_LESSON](state, payload) {
            // payload -> lessonIndex, lessonLength
            let lessons = _.clone(state.plan.lessons);
            let targetIndex = payload.lessonIndex - 1;
            let prevIndex = targetIndex - 1;
            if (targetIndex) {
                let prev = lessons[prevIndex];
                prev.index = payload.lessonIndex;
                let target = lessons[targetIndex];
                target.index = targetIndex;
                state.plan.lessons.splice(prevIndex, 2, target, prev);
            }
        },
        [TypesStudent.STUDENT_PLAN_DOWN_LESSON](state, payload) {
            // payload -> lessonIndex, lessonLength
            let lessons = _.clone(state.plan.lessons);
            let targetIndex = payload.lessonIndex - 1;
            let nextIndex = targetIndex + 1;
            if (payload.lessonIndex !== payload.lessonLength) {
                let next = lessons[nextIndex];
                next.index = payload.lessonIndex;
                let target = lessons[targetIndex];
                target.index = payload.lessonIndex + 1;
                state.plan.lessons.splice(targetIndex, 2, next, target);
            }
        },
        [TypesStudent.STUDENT_SET_KNPWLEDGE_TREE](state, payload) {
            state.course = payload || [];
        },
        [TypesStudent.STUDENT_SET_LIST](state, payload) {
            state.studentList = payload || [];
        },
        // 筛选题目
        [TypesStudent.STUDENT_SET_SELECTEXAM_TREE](state, payload) {
            state.selectCourse = payload || {};
        },
        STUDENT_SET_PENDING(state, payload) {
            state.hasPendingHomework = payload;
        }
    },
    actions: {
    // 获取学生的基本信息
        [TypesStudent.STUDENT_GET_BASE_INFO](ctx, studentId) {
            return Vue.http.get(`/v1/students/${studentId}/basic-info`)
                .then(resp => {
                    return Vue.checkResp(resp);
                }).then(data => {
                    // console.log(data);
                    ctx.commit(TypesStudent.STUDENT_SET_BASE_INFO, data);
                    return data;
                }).catch(err => {
                    ctx.commit(TypesStudent.STUDENT_SET_BASE_INFO, null);
                    throw err;
                });
        },
        // 获取学生最近课程安排信息
        [TypesStudent.STUDENT_GET_RECENT_LESSON](ctx, studentId) {
            return Vue.http.get(`/v1/students/${studentId}/recent-lesson`)
                .then(resp => {
                    return Vue.checkResp(resp);
                }).then(data => {
                    ctx.commit(TypesStudent.STUDENT_SET_RECENT_LESSON, data);
                    return data;
                }).catch(err => {
                    ctx.commit(TypesStudent.STUDENT_SET_RECENT_LESSON, null);
                    throw err;
                });
        },
        // 获取学生辅导科目
        [TypesStudent.STUDENT_GET_TUTOR_SUBJECT](ctx) {
            return Vue.http.get(`/v1/user-center/teaching-info`)
                .then(resp => {
                    return Vue.checkResp(resp);
                }).then(data => {
                    ctx.commit(TypesStudent.STUDENT_GET_TUTOR_SUBJECT, data);
                    return data;
                }).catch(err => {
                    ctx.commit(TypesStudent.STUDENT_GET_TUTOR_SUBJECT, null);
                    throw err;
                });
        },
        // 获取备课记录
        [TypesStudent.STUDENT_GET_LESSON_LIST](ctx, { start, limit, studentUsername }) {
            return Vue.http.get(`/v1/online-coursewares/list`, { params: { start: start, limit: limit, studentUsername: studentUsername } })
                .then(resp => {
                    return Vue.checkResp(resp);
                }).then(data => {
                    // console.log(data);
                    return data;
                }).catch(err => {
                    throw err;
                });
        },
        // 获取课程记录
        [TypesStudent.STUDENT_GET_HISTORY_COURSE](ctx, { limit, studentId, start }) {
            return Vue.http.get(`/v1/lessons/historical-lessons`, {
                params: {
                    limit: limit,
                    studentId: studentId,
                    start: start
                }
            }).then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                ctx.commit(TypesStudent.STUDENT_SET_HISTORY_COURSE, data);
                return data;
            }).catch(err => {
                ctx.commit(TypesStudent.STUDENT_SET_HISTORY_COURSE, null);
                throw err;
            });
        },
        // 获取作业列表
        [TypesStudent.STUDENT_GET_HOMEWORK_LIST](ctx, { studentUsername, homeworkStatus, start, limit }) {
            return Vue.http.get(`/v1/homework/list`, {
                params: {
                    studentUsername: studentUsername,
                    homeworkStatus: homeworkStatus,
                    start: start,
                    limit: limit
                }
            })
                .then(resp => {
                    return Vue.checkResp(resp);
                }).then(data => {
                    if (!studentUsername && !homeworkStatus) {
                        ctx.commit(TypesStudent.STUDENT_SET_HOMEWORK_LIST, data.homework);
                    }
                    if (!studentUsername && (!homeworkStatus || homeworkStatus === 2)) {
                        // 当请求不筛选名字且状态为全部或待批改时 根据列表第一项的状态类型判断是否存在待批改作业 并更新hasPendingHomework
                        const firstHomework = data.homework[0];
                        ctx.commit('STUDENT_SET_PENDING', firstHomework && firstHomework.hwStatus === 2);
                    }
                    return data;
                }).catch(err => {
                    if (!studentUsername && !homeworkStatus) {
                        ctx.commit(TypesStudent.STUDENT_SET_HOMEWORK_LIST, null);
                    }
                    throw err;
                });
        },
        [TypesStudent.STUDENT_GET_COURSE_PLANS](ctx, studentId) {
            return Vue.http.get(`/v1/students/${studentId}/course-plans`)
                .then(resp => {
                    return Vue.checkResp(resp);
                }).then(data => {
                    if (data && data[0]) {
                        let coursePlan = data[0];
                        coursePlan.subjectStr = coursePlan.subject ? Enums.Subject[coursePlan.subject] : '';
                        coursePlan.lessonsTotal = coursePlan.lessons ? coursePlan.lessons.length : 0;
                        if (coursePlan.lessonsTotal) {
                            coursePlan.lessons.forEach(item => {
                                item.subjectStr = coursePlan.subjectStr;
                                if (item.startTime) {
                                    item.dayTime = Moment(item.startTime).format('YYYY-MM-DD');
                                    item.hourTime = Moment(item.startTime).format('HH:mm') + '~' + Moment(item.endTime).format('HH:mm');
                                } else {
                                    item.dayTime = '待定';
                                    item.hourTime = '';
                                }
                                let knowledgeArray = [];
                                item.knowledgePoints && item.knowledgePoints.forEach(point => {
                                    knowledgeArray.push(point.name);
                                });
                                item.knowledges = knowledgeArray.join(';');
                            });
                        }
                        return coursePlan;
                    }
                    return {};
                }).catch(err => {
                    throw err;
                });
        },
        [TypesStudent.STUDENT_GET_FREE_LESSONS](ctx, studentId) {
            return Vue.http.get(`/v1/students/${studentId}/free-lessons`)
                .then(resp => {
                    return Vue.checkResp(resp);
                }).then(data => {
                    if (data && data.length) {
                        data.forEach(item => {
                            item.subjectStr = item.subject ? Enums.Subject[item.subject] : '';
                            item.dayTime = Moment(item.startTime).format('YYYY-MM-DD');
                            item.hourTime = Moment(item.startTime).format('HH:mm') + '~' + Moment(item.endTime).format('HH:mm');
                            let knowledgeArray = [];
                            item.knowledgePoints && item.knowledgePoints.forEach(point => {
                                knowledgeArray.push(point.name);
                            });
                            item.knowledges = knowledgeArray.join(';');
                        });
                        return data;
                    }
                    return [];
                }).catch(err => {
                    throw err;
                });
        },
        // 获取课程详情
        [TypesStudent.STUDENT_GET_PLAN](ctx, planId) {
            return Vue.http.get(`/v1/courses/${planId}`)
                .then(resp => {
                    return Vue.checkResp(resp);
                }).then(data => {
                    if (data) {
                        data.subjectStr = data.subject ? Enums.Subject[data.subject] : '';
                        if (data.lessons) {
                            data.lessons.forEach((item, idx) => {
                                item.index = idx + 1;
                                item.subjectStr = item.subject ? Enums.Subject[item.subject] : '';
                                if (item.startTime) {
                                    item.dayTime = Moment(item.startTime).format('YYYY-MM-DD');
                                    item.hourTime = Moment(item.startTime).format('HH:mm') + '~' + Moment(item.endTime).format('HH:mm');
                                } else {
                                    item.dayTime = '待定';
                                    item.hourTime = '';
                                }
                                let knowledgeArray = [];
                                item.knowledgePoints && item.knowledgePoints.forEach(point => {
                                    knowledgeArray.push(point.name);
                                });
                                item.knowledges = knowledgeArray.join(';');
                                // 判断是否隐藏增加课节 hideAddLesson
                                let nextLesson = data.lessons[idx + 1];
                                if (nextLesson && nextLesson.isFinished) {
                                    item.hideAddLesson = true;
                                }
                            });
                        }
                        ctx.commit(TypesStudent.STUDENT_SET_PLAN, data);
                        return data;
                    }
                    ctx.commit(TypesStudent.STUDENT_SET_PLAN, null);
                    return {};
                }).catch(err => {
                    ctx.commit(TypesStudent.STUDENT_SET_PLAN, null);
                    throw err;
                });
        },
        // 修改课程规划
        [TypesStudent.STUDENT_MODIFY_PLAN](ctx, { planId, lessons }) {
            return Vue.http.put(`/v1/course-plans/${planId}/course-schedule`, { lessons })
                .then(resp => {
                    return Vue.checkResp(resp);
                }).then(data => {
                    return data;
                }).catch(err => {
                    throw err;
                });
        },
        // 获取学生列表
        [TypesStudent.STUDENT_GET_LIST](ctx, { boundRelationship, searchContent }) {
            return Vue.http.get('/v1/students/list', {
                params: {
                    boundRelationship: boundRelationship,
                    searchContent: searchContent
                }
            }).then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                // 只保存所有课程列表 (且搜索内容为空)
                if (!boundRelationship && !searchContent) {
                    ctx.commit(TypesStudent.STUDENT_SET_LIST, data);
                }
                return data;
            }).catch(err => {
                if (!boundRelationship && !searchContent) {
                    ctx.commit(TypesStudent.STUDENT_SET_LIST, null);
                }
                throw err;
            });
        },
        // 获取教材树打包信息
        [TypesStudent.STUDENT_GET_KNPWLEDGE_TREE](ctx) {
            return Vue.http.get('/v1/knowledge-base/dmp/book-tree').then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                ctx.commit(TypesStudent.STUDENT_SET_KNPWLEDGE_TREE, data);
                return data;
            }).catch(err => {
                throw err;
            });
        },
        // 根据教材获取知识点
        [TypesStudent.STUDENT_GET_KNPWLEDGE_LIST](ctx, { bookId, kbMode, knowledgePointsConstruct, searchKnowledgePoint }) {
            return Vue.http.get(`/v1/knowledge-base/books/${bookId}/knowledge-points`, { params: { kbMode: kbMode, knowledgePointsConstruct: knowledgePointsConstruct, searchKnowledgePoint: searchKnowledgePoint } })
                .then(resp => {
                    return Vue.checkResp(resp, []);
                }).then(data => {
                    return data;
                }).catch(err => {
                    throw err;
                });
        },
        // 筛选条件
        [TypesStudent.STUDENT_GET_SELECTEXAM_TREE](ctx) {
            return Vue.http.get('/v1/knowledge-base/kb-knowledge-points/2101084159/filters').then(resp => {
                return Vue.checkResp(resp);
            }).then(data => {
                ctx.commit(TypesStudent.STUDENT_SET_SELECTEXAM_TREE, data.selectCourse);
                return data;
            }).catch(err => {
                throw err;
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/index/store/modules/modules_student.js